import { downgradeComponent } from '@angular/upgrade/static';
import { ReportFieldComponent } from '@fry-it/risr-features/reports';

(function() {
  'use strict';

  function SQLReportFieldComponent() {
    var ctrl = this;

    ctrl.$onInit = function() {
      ctrl.model = ctrl.model || {};
      console.log('SQLReportFieldComponent', ctrl.model, ctrl.extra, ctrl.report, ctrl.reportId);
    };

    ctrl.update = function(value) {
      if (ctrl.readOnly) {
        console.log('An attempt to update a readonly report');
        return;
      }
      ctrl.model = value;
    };
  }

  SQLReportFieldComponent.$inject = [];

  angular.module('component.sqlreports')
    .directive('sqlReportField', downgradeComponent({
      component: ReportFieldComponent,
      inputs: [
        'model',
        'extra',
        'report',
        'reportId',
        'readOnly'
      ],
      outputs: [
        'update'
      ]
    }))
    .component('sqlReportFieldWrapper', {
      templateUrl: 'app/components/sqlreports/sqlreport-field.component.html',
      controller: SQLReportFieldComponent,
      bindings: {
        model: '=',
        extra: '<',
        report: '<',
        reportId: '<',
        readOnly: '<'
      }
    });
})();
